import storage from '$common/utils/storage';

export default {
  data() {
    return {
      userInfo: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (!window.location.href.includes('sleepless-city') && !window.location.href.includes('christmas-mystery') && !window.location.href.includes('christmas-reward-list')) {
          this.getUserInfo()
        }
      })
    })
  },
  methods: {
    getUserInfo() {
      return new Promise((resolve, reject) => {
        console.log('this.$root.isWownowApp: ', this.$root.isWownowApp)
        this.$root.timeout(() => {
          console.log('go get user info')
          if (this.$root.isWownowApp && window?.WOWNOW?.getUserInfo) {
            window.WOWNOW.getUserInfo({
              success: res => {
                console.log('user info res is:', res)
                if (res && res.loginName) {
                  storage.setItem('loginName', res.loginName)
                  storage.setItem('operatorNo', res.operatorNo)
                  this.userInfo.loginName = res.loginName;
                  this.userInfo.operatorNo = res.operatorNo;
                  resolve(res)
                }
              },
              fail: res => {
                console.log('get user info fail')
                window?.WOWNOW?.navigationToRoute({
                  route: 'SuperApp://SuperApp/login'
                });
                window?.WOWNOW?.closeWindow();
                reject()
              }
            })
          } else {
            console.error('当前环境没有js sdk')
            reject()
          }
        })
      })
    }
  }
}